export const ANY_VALUE_PARTITION_GUID = '73e4b32acf5b3b94:-6b17d22d:117408ebd2b:-7c1a'
export const ANY_VALUE_STRING_DEFAULT = '[Any]'
export const ALL_VALUE_STRING_DEFAULT = '[All]'
export const NONE_VALUE_STRING_DEFAULT = '[None]'
export const ANY_VALUE_STRING_NUMERIC = '-1'
export const ANY_VALUE_NUMBER_NUMERIC = -1
export const NOT_DEFINED_VALUE_STRING = '[Not Defined]'
export const ANY_DEVICE_VALUE: string = 'UnknownNoneOrAll'

export const ALL_VALUE: number = -1
export const EMPTY_VALUE: string = ''
export const INVALID_VALUE: number = -3
